import script from "./DangerConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DangerConfirmModal.vue?vue&type=script&setup=true&lang=ts"

export default script